import { color } from "@mui/system";
import styled from "styled-components";
export const Wrapper = styled.div`
   .hidden {
      display: none;
   }
   .error {
      color: red;
      margin-top: -30px;
      margin-bottom: 30px;
   }
`;
